<template lang="pug">
  v-select(
    ref="root"
    v-bind="$attrs"
    v-model="model"
    readonly
    item-text="label"
    @click.native="onClick")
    template(#selection="{ item, index }")
      span(v-if="index === 0") {{ item.label }}
      span.ml-3.caption(
        v-if="index === 1"
        :class="menuIsOpened ? undefined : `grey--text`")
        | et {{ $pluralize({ word: `autre`, count: value.length - 1 }) }}
</template>

<script>
import {
  computed,
  ref
} from '@vue/composition-api'

import { page } from '@iez/core'
import { mdiHome } from '@mdi/js'

export default {
  inheritAttrs: false,

  props: {
    value: Array,
    max: Number,
    min: {
      type: Number,
      default: 0
    }
  },

  setup (props, { emit, attrs }) {
    const menuIsOpened = ref(false)
    const root = ref(null)

    const model = computed({
      get: () => props.value,
      set: value => {
        emit(
          `input`,
          value
        )
      }
    })

    page.blockingMenu.set(() => menuIsOpened.value
      ? ({
        title: `${attrs.label}${props.max ? ` (${props.max} max)` : undefined}`,
        items: attrs.items
          .map(item => ({
            ...item,
            value: !!props.value.find(({ id }) => item.id === id)
          })),
        select: {
          max: props.max,
          min: props.min
        },
        onClose: () => {
          menuIsOpened.value = false
          setTimeout(
            () => {
              root.value.blur()
            },
            0
          )
        },
        onResult: ({ indexes }) => {
          const result = attrs.items
            .filter(
              (_, index) =>
                indexes.includes(index)
            )
          emit(
            `input`,
            result
          )
        }
      }) : null
    )

    const onClick = () => {
      menuIsOpened.value = true
    }

    return {
      model,
      onClick,
      root,
      menuIsOpened
    }
  }
}
</script>
